import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ImageGrid = ({ images, onImageClick, favorites, onToggleFavorite }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
      {images.map((image, index) => (
        <div
          key={image.id}
          // The 'group' class allows child elements to react to hover on this parent
          className="group relative overflow-hidden rounded-lg elevation-card hover:elevation-floating transition-smooth cursor-pointer"
          onClick={() => onImageClick(index)}
        >
          {/* --- THIS IS THE MAIN CHANGE --- */}
          {/* We create a container that enforces a 4:3 aspect ratio. */}
          {/* The image inside will fill this container perfectly. */}
          <div className="aspect-w-4 aspect-h-3 bg-muted"> {/* A background color provides a nice placeholder while images load */}
            <Image
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
              loading="lazy" // Improves performance for users
            />
          </div>
          
          {/* Desktop Hover Overlay (No changes needed) */}
          <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-smooth hidden md:flex items-center justify-center">
            <button
              onClick={(e) => {
                e.stopPropagation(); // Prevents the lightbox from opening
                onToggleFavorite(image.id);
              }}
              className={`p-3 rounded-full glassmorphic transition-smooth hover-scale ${
                favorites.includes(image.id) 
                  ? 'text-accent bg-accent/20' :'text-white bg-white/20'
              }`}
              aria-label={favorites.includes(image.id) ? 'Remove from favorites' : 'Add to favorites'}
            >
              <Icon 
                name={"Heart"} 
                size={20}
                className={favorites.includes(image.id) ? "fill-current" : ""}
              />
            </button>
          </div>

          {/* Mobile Favorite Button (No changes needed) */}
          <button
            onClick={(e) => {
              e.stopPropagation(); // Prevents the lightbox from opening
              onToggleFavorite(image.id);
            }}
            className={`absolute top-3 right-3 p-2 rounded-full glassmorphic md:hidden transition-smooth ${
              favorites.includes(image.id) 
                ? 'text-accent bg-accent/20' :'text-white bg-white/20'
            }`}
            aria-label="Toggle favorite"
          >
            <Icon 
              name="Heart" 
              size={16}
              className={favorites.includes(image.id) ? "fill-current" : ""}
            />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ImageGrid;